import React from "react";

import CrossEntityMobileNavigation from "./CrossEntityMobileNavigation";

type MobileNavigationProps = {
	hasOffers: boolean;
	offersCount: number;
	sellOrdersCount: number;
};

const MobileNavigation = (props: MobileNavigationProps) => (
	<CrossEntityMobileNavigation {...props} />
);

export default MobileNavigation;
